import { BulkDeleteButton } from 'react-admin'
import { useCanAccess } from '../../hooks'

export const BulkActionButtonsWithPermission: React.FC = () => {
  const { permission } = useCanAccess()
  if (!permission) return null
  return (
    <>
      {/* default bulk delete action */}
      {permission.deletable && <BulkDeleteButton />}
    </>
  )
}
